import React, { useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import registerSchema from "../../../validationSchemas/ContactSchema";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { appConfig } from "../../../config/config";

const BannerContactForm = () => {
  const form = useRef();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(registerSchema),
  });

  const onSubmitForm = async (formData) => {
    try {
      const response = await fetch(
        "https://www.lagunacreek.io/blog/wp-json/custom-form/v1/submit",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            msg: formData.message,
          }),
        },
      );

      const resp = await response.json();

      console.log("SERVER RESPONSE:", resp);

      if (!response.ok) {
        alert(resp.message || "Something went wrong");
        return;
      }

      if (resp.status === "success") {
        navigate("/thank-you");
      }
    } catch (error) {
      console.error("Submit error:", error);
      alert("Server error");
    }
  };

  // const onSubmitForm = async (formData) => {
  //   const response = await fetch(`${appConfig.baseUrl}/zoho/`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       name: formData.name,
  //       email: formData.email,
  //       phone: formData.phone,
  //       msg: formData.message,
  //     }),
  //   });

  //   const resp = await response.json();

  //   if (!response.ok) {
  //     console.error("Error from server:", resp);
  //     alert("There was a problem submitting the form. Please try again.");
  //     return;
  //   }

  //   const statusCode = resp?.zoho_response?.code ?? null;

  //   if (statusCode === "success") {
  //     navigate("/thank-you");
  //   }
  // };

  return (
    <>
      <form ref={form} onSubmit={handleSubmit(onSubmitForm)}>
        <div className="mb-8">
          <div className="relative">
            <label className="text-base font-bold leading-none text-white tracking-[0.3px] px-2.5 bg-[#B35526] absolute -top-[9px] left-[15px]">
              Full Name *
            </label>
            <input
              {...register("name")}
              type="text"
              className="block w-full text-base font-light leading-none text-white bg-transparent py-[19px] px-[25px] rounded-[10px] border border-[#F1F1F1] tracking-[0.3px] focus:outline-none placeholder:text-[rgba(245,245,245,0.5)]"
              placeholder="Enter your full name"
            />
            {errors.name && (
              <p className="text-sm font-light text-[#FFF] mt-1">
                {errors.name.message}
              </p>
            )}
          </div>
        </div>
        <div className="mb-8">
          <div className="relative">
            <label className="text-base font-bold leading-none text-white tracking-[0.3px] px-2.5 bg-[#B35526] absolute -top-[9px] left-[15px]">
              Email *
            </label>
            <input
              {...register("email")}
              type="email"
              className="block w-full text-base font-light leading-none text-white bg-[transparent] py-[19px] px-[25px] rounded-[10px] border border-[#F1F1F1] tracking-[0.3px] focus:outline-none placeholder:text-[rgba(245,245,245,0.5)]"
              placeholder="Enter your email address"
            />
            {errors.email && (
              <p className="text-sm font-light text-[#FFF] mt-1">
                {errors.email.message}
              </p>
            )}
          </div>
        </div>
        <div className="mb-8">
          <div className="relative">
            <label className="text-base font-bold text-white px-2.5 bg-[#B35526] absolute -top-[9px] left-[15px] z-10">
              Phone number *
            </label>
            <Controller
              control={control}
              name="phone"
              rules={{ required: "Phone number is required" }}
              render={({ field: { onChange, onBlur, value, name, ref } }) => (
                <PhoneInput
                  country={"us"}
                  enableSearch={true}
                  value={value}
                  onChange={onChange}
                  inputProps={{
                    name,
                    required: true,
                    onBlur,
                    ref,
                    className:
                      "w-full text-white bg-transparent py-[19px] pl-[75px] pr-[19px] rounded-[10px] border border-[#F1F1F1] focus:outline-none placeholder:text-[rgba(245,245,245,0.5)]",
                  }}
                />
              )}
            />
            {errors.phone && (
              <p className="text-sm text-[#FFF] mt-1">{errors.phone.message}</p>
            )}
          </div>
        </div>
        <div className="mb-8">
          <div className="relative">
            <label className="text-base font-bold leading-none text-white tracking-[0.3px] px-2.5 bg-[#B35526] absolute -top-[9px] left-[15px]">
              How can we help?
            </label>
            <textarea
              {...register("message")}
              className="block w-full text-base font-light leading-none text-white bg-[transparent] py-[19px] px-[25px] rounded-[10px] border border-[#F1F1F1] tracking-[0.3px] focus:outline-none placeholder:text-[rgba(245,245,245,0.5)] min-h-[80px]"
              placeholder="Type your question or message here..."
            ></textarea>
            {errors.message && (
              <p className="text-sm font-light text-[#FFF] mt-1">
                {errors.message.message}
              </p>
            )}
          </div>
        </div>
        <div className="mb-0">
          <button
            type="submit"
            className="block w-full text-lg font-bold leading-6 text-[#111111] bg-white border border-white py-[17px] px-[17px] md:px-[35px] rounded-[7px] transition-all ease-in-out duration-500 text-center hover:text-white hover:bg-[#5FA3B2] hover:border-[#5FA3B2]"
          >
            Send your request
          </button>
        </div>
      </form>
    </>
  );
};

export default BannerContactForm;
